import React, {useEffect, useRef} from 'react'
import styled from "@emotion/styled";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {notify_show_state, notify_state} from "../../../common/atom/dialog";
import phoneIcon from "../../../common/emotion/images/i_phone.svg";

const Container = styled.div`
    position: absolute;
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);

    &:focus{
        border: 1px solid #000;
    }
`

const Box = styled.div`
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 2.25rem 1.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    width: 80%;
    background: white;
    border-radius: 16px;
    min-height: 180px;
    height: auto;
`

const Icon = styled.i`
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #eee;
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: url(${phoneIcon});
    background-repeat: no-repeat;
    background-position: center;
    margin-bottom: 20px;
`

const Title = styled.div`
    font-size: 1.25rem;
    font-weight: bold;
    line-height: 26px;
    text-align: center;
    margin-bottom: 24px;
    letter-spacing: 0;
    white-space: pre-wrap;
    color: ${({theme}) => theme.primary.bk01};

    strong {
        color: ${({theme}) => theme.primary.bl01};
    }
`


const Message = styled.div`
    font-size: 0.8125rem;
    font-weight: normal;
    line-height: 20px;
    text-align: center;
    letter-spacing: 0;
    white-space: pre-wrap;
    color: ${({theme}) => theme.primary.bk01};
    margin-bottom: 22px;

`
const ButtonBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    gap: 6px;
    margin-top: 10px;
`

const CancelBtn = styled.button`
    min-width: 47%;
    min-height: 50px;
    border-radius: 0.75rem;
    background-color: ${({theme}) => theme.button.disabled.background};
    color: ${({theme}) => theme.button.disabled.text};
    border: none;
    cursor: pointer;
    font-size: 1rem;

    font-weight: 500;
    line-height: 20px;
    text-align: center;
    letter-spacing: 0;
`

const ConfirmBtn = styled(CancelBtn)`
    background-color: ${({theme}) => theme.button.background};
    color: ${({theme}) => theme.button.text};
    width: 100%;
`

export default function Notification() {
    const {title, message, confirm, cancel} = useRecoilValue(notify_state);
    const setShow = useSetRecoilState(notify_show_state);
    const ref = useRef<HTMLDivElement>(null);

  
    const onConfirm = () => {
         setShow(false); 
        if (confirm) confirm();
    }

    const onCancel = () => {
         setShow(false); 

        if (cancel) cancel();
    }
    useEffect(() => {
        ref.current?.focus();
    }, []);

    return (
        <Container>
            <Box role="alertdialog" tabIndex={0} ref={ref} >
                <Icon/>
                <Title tabIndex={0} role='text'>{title}</Title>
                <Message tabIndex={0} role='text'>{message}</Message>
                <ButtonBox>
                    <CancelBtn onClick={onCancel} role="button" tabIndex={0}>취소</CancelBtn>
                    <ConfirmBtn onClick={onConfirm} role="button" tabIndex={0}>확인</ConfirmBtn>
                </ButtonBox>
            </Box>
        </Container>
    )
}
